import { render, staticRenderFns } from "./tkCabin.vue?vue&type=template&id=23f810de&scoped=true&"
import script from "./tkCabin.vue?vue&type=script&lang=js&"
export * from "./tkCabin.vue?vue&type=script&lang=js&"
import style0 from "./tkCabin.vue?vue&type=style&index=0&id=23f810de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f810de",
  null
  
)

export default component.exports